import React, { useEffect, useState } from 'react';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../firebaseConfig';

const ManageNews = ({ onEdit }) => {
  const [news, setNews] = useState([]);
  
  useEffect(() => { loadNews(); }, []);
  
  const loadNews = async () => {
    const snap = await getDocs(collection(db, "news"));
    // Timestamp order mein lana ho toh sort bhi kar sakte hain
    setNews(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this news?")) {
      await deleteDoc(doc(db, "news", id));
      loadNews(); // List refresh
    }
  };

  return (
    <div className="manage-wrapper">
      <h2>Manage News Content</h2>
      
      {/* Scrollable Container */}
      <div className="scrollable-news-list" style={{ maxHeight: '600px', overflowY: 'auto' }}>
        {news.map(item => (
          <div key={item.id} className="news-row">
            <div className="news-info">
              <span className="news-title-text">{item.titleEn || item.titleUr || "Untitled News"}</span>
              <small style={{display: 'block', color: '#64748b'}}>{item.date}</small>
            </div>
            <div className="actions-group">
              <button className="btn-action btn-edit" onClick={() => onEdit(item)}>Edit</button>
              <button className="btn-action btn-delete" onClick={() => handleDelete(item.id)}>Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default ManageNews;